import { digitalManagerApi } from "../../services/api"
import { getResolver, isLikelyGuid } from "./resolverMap"
import { BreadcrumbUnit, ResolverContext } from "./types"

export type BreadcrumbQuery = {
  unitIndex: number
  queryKey: readonly unknown[]
  queryFn: () => Promise<unknown>
  select: (data: unknown) => string
}

function tryBuildQuery(
  unit: BreadcrumbUnit,
  index: number,
  ids: Record<string, string>,
  parents: Set<string>
): BreadcrumbQuery | undefined {
  if (!unit.id || !isLikelyGuid(unit.id)) {
    return undefined
  }
  const resolver = getResolver(unit.name)
  if (!resolver) {
    return undefined
  }
  const ctx: ResolverContext = {
    ids: { ...ids },
    parents: new Set(parents),
    currentId: unit.id,
  }
  const endpoint = resolver.endpoint(ctx)
  if (!endpoint) {
    return undefined
  }
  return {
    unitIndex: index,
    queryKey: resolver.queryKey(ctx),
    queryFn: () => digitalManagerApi.get(endpoint).then((r) => r.data),
    select: resolver.select,
  }
}

export function buildQueries(units: BreadcrumbUnit[]): BreadcrumbQuery[] {
  const result: BreadcrumbQuery[] = []
  const ids: Record<string, string> = {}
  const parents = new Set<string>()

  for (let k = 0; k < units.length; k++) {
    const unit = units[k]
    const query = tryBuildQuery(unit, k, ids, parents)
    parents.add(unit.name)
    if (unit.id) {
      ids[unit.name] = unit.id
    }
    if (query) {
      result.push(query)
    }
  }

  return result
}
